class EasyBundleBuilder extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.setVariables();
        this.setEvents();
        this.init();
    }

    setVariables() {
        this.id = this.getAttribute('id');
        this.products = this.querySelectorAll('.easy-bundle-builder-product'); 
        this.addToCartForm = document.querySelector('product-form form');
        this.addToCartButton = document.querySelector('product-form button[name="add"]');
        this.bundlePrice = this.getAttribute('data-bundle-price');
        this.bundleCompareAtPrice = this.getAttribute('data-bundle-compare-at-price');
        this.disableBundlePriceUpdate = this.getAttribute('data-disable-prices-update');
    }

    setEvents() {
        this.products.forEach(product => {
            product.querySelector('select')?.addEventListener('change', this.onProductChange.bind(this));
        });

        this.addToCartButton?.addEventListener('click', this.onAddToCartButtonClick.bind(this));
    }

    init() {
        console.log('EasyBundleBuilder initialized with bundle:', window.gbbMix.sdk.state.bundleName);
    }

    get bundleDiscountAmount() {
        return this.bundleCompareAtPrice - this.bundlePrice;
    }

    get bundleDiscountPercentage() {
        return Math.floor((this.bundleDiscountAmount * 100) / this.bundleCompareAtPrice);
    }

    onProductChange(event) {
        const target = event.target;

        this.updateProductInfo(target);
        this.updateBundlePrice(target);
    }

    updateProductInfo(target) {
        const product = target.closest('.easy-bundle-builder-product');
        const image = product.querySelector('.easy-bundle-builder-image');
        
        target.setAttribute('value', target.value);
        image.src = target.options[target.selectedIndex].dataset.img;
        image.setAttribute("alt", target.options[target.selectedIndex].dataset.img.alt);
    }

    updateBundlePrice(target) {
        if (this.disableBundlePriceUpdate === 'true') return;

        const productPagePriceContainer = target.closest('.product').querySelector('.price__comment-container').querySelector('.price__container');
        const priceRegularElement = productPagePriceContainer.querySelector('.price__regular .price-item--regular .money') || productPagePriceContainer.querySelector('.price__regular .price-item--regular');
        const priceSaleRegularElement = productPagePriceContainer.querySelector('.price__sale .price-item--regular .money') || productPagePriceContainer.querySelector('.price__sale .price-item--regular');
        const priceSaleSaleElement = productPagePriceContainer.querySelector('.price__sale .price-item--sale .money') || productPagePriceContainer.querySelector('.price__sale .price-item--sale');
        let price = 0;
        let finalRegularPrice = 0;
        let finalSalePrice = 0;

        this.products.forEach(product => {
            let productPrice = parseFloat(product.querySelector('select')?.options[product.querySelector('select').selectedIndex].dataset.price);            
            if (isNaN(productPrice)) productPrice = parseFloat(product.querySelector('input')?.dataset.price);
            price += productPrice;
        });

        finalRegularPrice = price;
        finalSalePrice = finalRegularPrice - (finalRegularPrice * this.bundleDiscountPercentage / 100);

        if (priceRegularElement) priceRegularElement.innerHTML = formatPrice(finalRegularPrice);
        if (priceSaleRegularElement) priceSaleRegularElement.innerHTML = formatPrice(finalRegularPrice);
        if (priceSaleSaleElement) priceSaleSaleElement.innerHTML = formatPrice(finalSalePrice);
    }

    onAddToCartButtonClick(event) {
        event.preventDefault();
        this.updateBundleContent();
        this.addBundleToCart();
    }

    updateBundleContent() {
       this.products.forEach(product => {
            const categoryId = window.gbbMix.sdk.state.categoriesData[product.dataset.index].id;
            const select = product.querySelector('select');
            const input = product.querySelector('input[type="hidden"]');
            let variantIdToAdd;

            if (select) {
                const selectedIndex = select.selectedIndex || 0;
                variantIdToAdd = select.options[selectedIndex].dataset.variantId;
            } else {
                variantIdToAdd = input.value;
            }
         
            try {
              window.gbbMix.sdk.f.addProductToBundle({
                categoryId: categoryId,
                variantId: variantIdToAdd,
                quantity: 1
              });
            } catch(error) {
              console.error("Failed to add product to bundle:", error);
            }            
        });
    }

    addBundleToCart() {
        //if (!this.bundleOK) return;
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
            window.location = window.routes.cart_url;
            return;
        }

        // Activer l'état de chargement sur le bouton immédiatement
        if (this.addToCartButton) {
            this.addToCartButton.setAttribute('aria-disabled', 'true');
            this.addToCartButton.classList.add('loading');
            const spinner = this.addToCartButton.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.remove('hidden');
        }

        // On garde un petit délai de 500ms pour laisser au SDK le temps de finir sa requête
        window.setTimeout(async () => {
            try {
                // Étape 1 : Ajouter le bundle via le SDK
                await window.gbbMix.sdk.f.addBundleToCart();

                // Étape 2 : Récupérer les sections du panier (GET est plus simple et fiable ici)
                const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
                const sectionsParam = sections.join(',');
                
                const response = await fetch(`${window.routes.cart_url}?sections=${sectionsParam}`, { 
                    method: 'GET', 
                    cache: 'no-store' 
                });

                if (!response.ok) throw new Error('Cart drawer refresh failed');

                const sectionsData = await response.json();

                // Étape 3 : Dispatch l'événement et afficher le contenu
                document.dispatchEvent(new Event('productAdded'));
                
                // On reformate pour correspondre à ce que renderContents attend
                cartDrawer.renderContents({
                    sections: sectionsData,
                    id: null
                });

            } catch (error) {
                console.error("Failed to add bundle to cart:", error);
                window.location = window.routes.cart_url;
            } finally {
                // Retirer l'état de chargement
                if (this.addToCartButton) {
                    this.addToCartButton.removeAttribute('aria-disabled');
                    this.addToCartButton.classList.remove('loading');
                    const spinner = this.addToCartButton.querySelector('.loading-overlay__spinner');
                    if (spinner) spinner.classList.add('hidden');
                }
            }
        }, 500);
    }

    get bundleOK() {
        this.products.forEach(product => {
            const categoryId = window.gbbMix.sdk.state.categoriesData[product.dataset.index].id;      
            const result = window.gbbMix.sdk.f.checkCategoryConditions(categoryId);

            if (result.conditionsSatisfied) {
                console.log("Conditions for category" + categoryId + "are satisfied.");
            } else {
                console.log(result.validationMessage);
                return false; // If any category does not satisfy conditions, return false
            }
        });

        return true; // All categories satisfied conditions
    }
}

customElements.define('easy-bundle-builder', EasyBundleBuilder);